
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWireOverlap as ObiWireOverlapElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wire-overlap.js';
 
 
 

 
 export const ObiWireOverlap = createComponent({
   react: React,
   tagName: 'obi-wire-overlap',
   elementClass: ObiWireOverlapElement,
   events: {
     
   }
  });
 
 